import axios from "axios";

const fetchClient = () => {
  // let token = JSON.parse(localStorage.getItem("persist:root"))?
  //     JSON.parse(JSON.parse(localStorage.getItem("persist:root")).auth)?
  //         JSON.parse(JSON.parse(localStorage.getItem("persist:root")).auth).token
  //         : null
  //     : null;
  // let token = JSON.parse(JSON.parse(localStorage.getItem("persist:root")).auth).token;

  let instance = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL
  });

  instance.interceptors.request.use(function (config) {

    let token = JSON.parse(localStorage.getItem("persist:root"))
      ? JSON.parse(JSON.parse(localStorage.getItem("persist:root")).auth)
        ? JSON.parse(JSON.parse(localStorage.getItem("persist:root")).auth)
            .token
        : null
      : null;

    if (token) {
      config.headers.common["Authorization"] = "Bearer " + token;
    }
    return config;
  });

  // if(token)
  // {
  //     instance.defaults.headers.common['Authorization'] = "Bearer "+token;
  // }

  return instance;
};

export default fetchClient();
